import React, { CSSProperties } from 'react';
import { Button, View, useAuthenticator } from '@aws-amplify/ui-react';
import { fonts } from '../../style/fonts';

/**
 * Footer for the "enter code + new password" step of Forgot Password.
 *
 * Amplify's own footer for this step offers only "Resend Code", so a user who
 * reached it by mistake (or whose code never arrives) had no way back to the
 * login page short of reloading. The first Forgot Password step already has
 * Amplify's "Back to Sign In" link; this gives the second step the same exit.
 * `toSignIn` works from here because the Authenticator's resetPassword state
 * handles SIGN_IN from every sub-step.
 */
export default function ConfirmResetPasswordFooter() {
  const { toSignIn } = useAuthenticator((context) => [context.route]);

  return (
    <View
      style={{
        paddingTop: '8px',
        paddingBottom: '12px',
        maxWidth: '420px',
      }}
    >
      <Button
        type="button"
        variation="link"
        size="small"
        fontWeight="normal"
        width="100%"
        onClick={toSignIn}
      >
        Back to Sign In
      </Button>
      {/*
        Shown to EVERYONE who reaches the code screen, on purpose.

        A never-activated invite (Cognito `FORCE_CHANGE_PASSWORD`) can never
        receive a reset code — Cognito refuses to reset a password that was
        never set, and sends no mail. That user is otherwise stuck on this
        screen forever waiting for a code that is not coming, which is exactly
        what happened to a real admin who retried over several hours.

        The fix cannot be a targeted error message: saying "this account isn't
        activated" would confirm the address exists and turn the form into an
        enumeration oracle. Showing the same hint unconditionally rescues the
        stranded user and tells an attacker nothing, because it is identical
        for every address.
      */}
      <span style={fonts.text as CSSProperties}>
        No code? If your account was just created and you have never signed in,
        a reset code cannot be sent yet — sign in with the temporary password
        from your administrator instead, and you will be asked to choose a
        password. If you no longer have it, ask them to resend the invitation.
      </span>
    </View>
  );
}
